import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SharedService } from '../../../providers/shared.service';
import { StorageService } from '../../../providers/storage.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '../../../providers/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'sm-block-unblock-users',
  templateUrl: './block-unblock-users.component.html',
  styleUrls: ['./block-unblock-users.component.scss']
})
export class BlockUnblockUsersComponent implements OnInit, OnDestroy {

  addDiscountForm : UntypedFormGroup;
  filteredList: any[] = []
  toCancelDocId:string = ''
formattedAddress: any = ''
entityHash: any = ''
  isMerchantSpecific:Boolean=false;
  isLocationSpecific:Boolean=false;
  isAllMerchant:Boolean=false;
  selectedMerchant:any=[];
  suggestedMerchant:any=[];
  isMerchantSelected:Boolean=false;
  entityList: any[] = [];
  objectoptions = [
    {name: 'angular'},
    {name: 'aise'}
  ]
  
  private apiSubscription: Subscription = new Subscription();
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private sharedService: SharedService,private storageService : StorageService ,public dialog: MatDialogRef<BlockUnblockUsersComponent>, private _apiservice: ApiService, private router: Router) { 
    this.addDiscountForm = new UntypedFormGroup({
     
      'cancellationNotes' : new UntypedFormControl(null,[Validators.required]),
      
  });

 
  }



  ngOnInit(): void {

console.log(this.data);


    


    
  }

  cancelVerification(){
 

if(this.data.type == 'block'){
  let data = { 
    type: 'user',
    reason: this.addDiscountForm.value.cancellationNotes,
    status: 2,
    hashId: this.data.profileHashId
 
 }

  
  this._apiservice.blockUnblockOperation(data);
  this.dialog.close();
  setTimeout(() => {
    this.sharedService.sendClickEvent();
  }, 2000);
}


else if(this.data.type == 'unblock'){
  let data = { 
    type: 'user',
    reason: this.addDiscountForm.value.cancellationNotes,
    status: 1,
    hashId: this.data.profileHashId
 
 }

  
  this._apiservice.blockUnblockOperation(data);
  this.dialog.close();
  setTimeout(() => {
    this.sharedService.sendClickEvent();
  }, 2000);
}




  }


  public closePopup(): void {
    this.dialog.close();
  }

  ngOnDestroy(): void {
    this.apiSubscription.unsubscribe();
  }

}
